/**
 * The front page.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readString } from '@/domain/json'
import { type CoverSection } from '@/domain/section'
import CoverBlock from '@/sections/cover/CoverBlock.vue'
import CoverInspector from '@/sections/cover/CoverInspector.vue'
import { DEFAULT_COVER_VARIANT, readCoverVariant } from '@/sections/cover/variants'
import type { SectionDefinition } from '@/sections/types'

export const coverSection: SectionDefinition<'cover', CoverSection> = {
  kind: 'cover',
  band: 'frontAndBack',

  icon: ['M3.5 2.5h9v11h-9z', 'M5.5 5.5h5', 'M5.5 8h3'],

  create: (id, title) => ({
    id,
    kind: 'cover',
    title,
    variant: DEFAULT_COVER_VARIANT,
    entity: '',
    period: '',
    subtitle: '',
    standard: '',
    picture: '',
    logo: '',
    note: '',
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'cover',
    title,
    variant: readCoverVariant(readString(stored, 'variant')),
    entity: readString(stored, 'entity'),
    period: readString(stored, 'period'),
    subtitle: readString(stored, 'subtitle'),
    standard: readString(stored, 'standard'),
    picture: readString(stored, 'picture'),
    logo: readString(stored, 'logo'),
    note: readString(stored, 'note'),
  }),

  block: CoverBlock,
  inspector: CoverInspector,
}
